import React from 'react'
import AppHeader from './Components/AppHeader/AppHeader'
import AppFooter from './Components/AppFooter/AppFooter'
import Layout from './Components/Layout/Layout'
import ContentRouter from './Components/ContentRouter/ContentRouter'
import './App.css'

const App = () => {
  return (
    <Layout
      header={<AppHeader />}
      content={<ContentRouter />}
      footer={<AppFooter />}
    />
  )
}

export default App
